export default "__VITE_ASSET__CBNQ5ZZy__"